module.exports = __webpack_public_path__ + "static/img/Verticalindustry.8421e5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/Verticalindustry.png
// module id = hou6
// module chunks = 44